/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { FormControl } from 'react-bootstrap';
import styles from './styles.scss';

const defaultProps = {
  placeholder: null,
};

const propTypes = {
  onChange: React.PropTypes.func.isRequired,
  placeholder: React.PropTypes.string,
  value: React.PropTypes.string.isRequired,
};

class SearchInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { value } = nextProps;
    if (value !== this.props.value) {
      this.setState({ value });
    }
  }

  render() {
    const { onChange, value, ...restProps } = this.props;        // eslint-disable-line
    return (
      <FormControl
        bsClass="aisz-form-control-o"
        className={styles.search}
        value={value}
        onChange={onChange}
        {...restProps}
      />
    );
  }
}

SearchInput.defaultProps = defaultProps;
SearchInput.propTypes = propTypes;

export default SearchInput;




// WEBPACK FOOTER //
// ./src/components/SearchInput/index.jsx